import { Button } from "@/components/ui/button.tsx";
import type { TimeRange } from "@/components/calendars/time-range-selection.ts";
import { formatChipLabel } from "@/components/calendars/time-range-selection.ts";
import { Clock, X } from "lucide-react";
import { UI_CONSTANTS } from "./constants.ts";

interface TimeRangeChipsProps {
  ranges: TimeRange[];
  onRemove: (rangeId: string) => void;
}

export const TimeRangeChips: React.FC<TimeRangeChipsProps> = ({ ranges, onRemove }) => {
  if (ranges.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {ranges.map((range) => (
        <div
          key={range.id}
          className="group flex items-center gap-1.5 px-2 py-1 rounded-md border bg-indigo-50 border-indigo-200 text-indigo-700 text-xs dark:bg-indigo-950 dark:border-indigo-800 dark:text-indigo-300"
        >
          <Clock className={UI_CONSTANTS.ICON_SIZE_SM} />
          <span>{formatChipLabel(range)}</span>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => onRemove(range.id)}
            aria-label="Remove time range"
            className="p-0 h-auto hover:bg-indigo-100 dark:hover:bg-indigo-900 rounded"
            data-statsig-name="time-range-chip-remove"
          >
            <X className={UI_CONSTANTS.ICON_SIZE_SM} />
          </Button>
        </div>
      ))}
    </div>
  );
};
